// extracted by mini-css-extract-plugin
export default {"elementProperties":"ElementProperties_elementProperties__jY-p3","propertyGroup":"ElementProperties_propertyGroup__JhRr0"};